import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { DomUtil } from "../../util/DomUtil";
import { EventUtil } from "../../util/EventUtil";
import { LandingCardLoader } from "../genericLanding/LandingCardLoader";
import { LandingCardLayout } from "../genericLanding/LandingCardLayout";

export class YearFilter extends Component {

  public _sortElements: HTMLElement[];
  public _button: HTMLElement;

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

    const query = DomUtil.queryAll.bind(null, element);
    this._sortElements = query(".dropdown-item");
    this._button = query(".year-filter-toggle")[0];

    if (!this._sortElements.length) {
      return;
    }

    // Server marks the requested (?ap=) year as active when it has listable
    // coverage; otherwise the first (newest) visible year is used.
    const selected =
      this._sortElements.find(el => el.classList.contains("active")) ||
      this._sortElements[0];

    // Switch years in place instead of a full page reload.
    this._sortElements.forEach(el =>
      el.addEventListener("click", ev => {
        ev.preventDefault();
        this.updateUrl(el);
        this.handleSortElementClick(el);
      })
    );

    // Always load the selected year once the card layout is ready, including
    // when ?ap= is present. Skipping this left the listing unfiltered.
    const cardLayout: LandingCardLayout | null = context.componentFactory.getComponent(
      LandingCardLayout
    );

    if (cardLayout) {
      this.handleSortElementClick(selected);
    } else {
      document.addEventListener(LandingCardLayout.LandingCardLayoutLoadedInit,
        () => this.handleSortElementClick(selected),
        { once: true }
      );
    }
  }

  public handleSortElementClick(e: HTMLElement): void {
    const sortOrder = e.getAttribute("data-sort") ?? "";
    console.log("sorting by: " + sortOrder);
    this.toggleActiveState(e);

    e.dispatchEvent(
      EventUtil.createCustomEvent(LandingCardLoader.LoadFilteredPageEvent,
        sortOrder));
  }

  public toggleActiveState(e: HTMLElement): void {
    this._sortElements.forEach(ct =>
      ct.classList.remove("active"));
      e.classList.add("active");
      this._button.textContent = e.textContent;
  }

  private updateUrl(e: HTMLElement): void {
    const year = e.getAttribute("data-sort");
    if (!year || !window.history || !window.history.replaceState) {
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set("ap", year);
    url.searchParams.delete("page");
    window.history.replaceState(window.history.state, "", url.toString());
  }
}

ComponentFactory.registerComponent("YearFilter",
YearFilter);
